var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.1032V28M23 34.7404C23 36 23 36 22 36C21 36 21 36 21 34.7404C21 33.3991 21 33.3991 22.118 33.3991C23 33.3991 23 33.3991 23 34.7404ZM38.6918 41.1121H5.30819C3.80424 41.1121 2.83838 39.5145 3.53723 38.1827L20.229 6.37476C20.9782 4.94722 23.0218 4.94722 23.771 6.37476L40.4628 38.1827C41.1616 39.5145 40.1958 41.1121 38.6918 41.1121Z",
    stroke: "#E00101",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedRequest);
export default __webpack_public_path__ + "static/media/failedRequest.c8f3a527f958752c8c8b686d2fc2aa11.svg";
export { ForwardRef as ReactComponent };